export const LEADS_FILTERS_STORAGE_KEY = 'leads-filters'
export const CALL_OPS_FILTERS_STORAGE_KEY = 'call-ops-filters'
export const TRACKING_FILTERS_STORAGE_KEY = 'tracking-filters'
export const FRONTLINE_FILTERS_STORAGE_KEY = 'frontline-filters'

export function clearFilterPersistenceOnLogout(): void {
  try {
    localStorage.removeItem(LEADS_FILTERS_STORAGE_KEY)
    localStorage.removeItem(CALL_OPS_FILTERS_STORAGE_KEY)
    localStorage.removeItem(TRACKING_FILTERS_STORAGE_KEY)
    localStorage.removeItem(FRONTLINE_FILTERS_STORAGE_KEY)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to clear filter persistence:', e)
  }
}
